module.exports = __webpack_public_path__ + "img/meeting_and_events.14973565.svg";